<div class="chart-wrapper">
    <!-- <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions" [plugins]="barChartPlugins" [legend]="barChartLegend" [chartType]="barChartType">
  </canvas> -->
    <!-- <canvas id="canvas"></canvas> -->
    <x-chartist [type]="type" [data]="data" [options]="options" [events]="events"></x-chartist>
</div>